var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 108,
    viewBox: "0 0 94 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 73,
    height: 87,
    fill: "#514C9F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 73,
    height: 87,
    fill: "#ECEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H84V81L66.5 97H11V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1925 99.4502H9.8789C9.18032 99.4502 8.61328 98.8824 8.61328 98.1846V9.81688C8.61328 9.1183 9.18032 8.55127 9.8789 8.55127H84.0597C84.7583 8.55127 85.3253 9.1183 85.3253 9.81688V80.3514C85.3253 80.6878 85.1918 81.0097 84.9536 81.2478L67.0858 99.0805C66.8486 99.3175 66.5279 99.4502 66.1925 99.4502ZM11.1445 96.918H65.6686L82.7934 79.8262V11.0825H11.1445V96.918Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2373 99.4507C65.5377 99.4497 64.9717 98.883 64.9717 98.1851L64.9752 80.3211C64.9762 79.6202 65.5432 79.0537 66.2443 79.0544L84.1083 79.0861C85.7736 79.0893 85.7718 81.6198 84.1039 81.6183L67.5071 81.5884L67.5044 98.1852C67.5029 98.8837 66.9359 99.4507 66.2373 99.4507Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89844 90.8983H1.3496C0.651017 90.8983 0.0839844 90.3305 0.0839844 89.6327V1.26561C0.0839844 0.567033 0.651019 0 1.3496 0H75.5298C76.2283 0 76.7954 0.567035 76.7954 1.26561V9.81547C76.7954 10.514 76.2278 11.0811 75.5298 11.0811H11.1638V89.6333C11.1638 90.3311 10.598 90.8983 9.89844 90.8983ZM2.61521 88.3663H8.63286V9.81472C8.63286 9.11614 9.19989 8.54911 9.89847 8.54911H74.2644V2.53047H2.6155L2.61521 88.3663Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3952 40.8999H33.8727C32.2065 40.8999 32.2065 38.3687 33.8727 38.3687H73.3942C75.0605 38.3687 75.0597 40.8999 73.3952 40.8999ZM26.2923 40.8999H20.5524C18.8862 40.8999 18.8862 38.3687 20.5524 38.3687H26.2923C27.9585 38.3687 27.9585 40.8999 26.2923 40.8999Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 52.5178H58.8849C57.2186 52.5178 57.2194 49.9866 58.8849 49.9866H73.3953C75.0618 49.9866 75.0606 52.5178 73.3953 52.5178ZM51.3046 52.5178H20.5524C18.8862 52.5178 18.8862 49.9866 20.5524 49.9866H51.3046C52.9708 49.9866 52.9708 52.5178 51.3046 52.5178Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3951 64.1279H46.0547C44.3889 64.1279 44.3889 61.5967 46.0547 61.5967H73.3951C75.0614 61.5967 75.0604 64.1279 73.3951 64.1279ZM38.4744 64.1279H20.5522C18.8862 64.1279 18.8862 61.5967 20.5522 61.5967H38.4744C40.1404 61.5967 40.1404 64.1279 38.4744 64.1279Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3951 75.7383H66.8991C65.2328 75.7383 65.2336 73.207 66.8991 73.207H73.3951C75.0613 73.207 75.0603 75.7383 73.3951 75.7383ZM59.3178 75.7383H20.5522C18.8862 75.7383 18.8862 73.207 20.5522 73.207H59.3178C60.9836 73.207 60.9841 75.7383 59.3178 75.7383Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3952 40.8999H33.8727C32.2065 40.8999 32.2065 38.3687 33.8727 38.3687H73.3942C75.0605 38.3687 75.0597 40.8999 73.3952 40.8999ZM26.2923 40.8999H20.5524C18.8862 40.8999 18.8862 38.3687 20.5524 38.3687H26.2923C27.9585 38.3687 27.9585 40.8999 26.2923 40.8999Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 52.5178H58.8849C57.2186 52.5178 57.2194 49.9866 58.8849 49.9866H73.3953C75.0618 49.9866 75.0606 52.5178 73.3953 52.5178ZM51.3046 52.5178H20.5524C18.8862 52.5178 18.8862 49.9866 20.5524 49.9866H51.3046C52.9708 49.9866 52.9708 52.5178 51.3046 52.5178Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3951 64.1279H46.0547C44.3889 64.1279 44.3889 61.5967 46.0547 61.5967H73.3951C75.0614 61.5967 75.0604 64.1279 73.3951 64.1279ZM38.4744 64.1279H20.5522C18.8862 64.1279 18.8862 61.5967 20.5522 61.5967H38.4744C40.1404 61.5967 40.1404 64.1279 38.4744 64.1279Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3951 75.7383H66.8991C65.2328 75.7383 65.2336 73.207 66.8991 73.207H73.3951C75.0613 73.207 75.0603 75.7383 73.3951 75.7383ZM59.3178 75.7383H20.5522C18.8862 75.7383 18.8862 73.207 20.5522 73.207H59.3178C60.9836 73.207 60.9841 75.7383 59.3178 75.7383Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5683 30.8575C19.8698 30.8575 19.3027 30.2904 19.3027 29.5921V15.5712C19.3027 13.905 21.834 13.905 21.834 15.5712V29.5921C21.834 30.2904 21.2679 30.8575 20.5683 30.8575Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0732 24.6242C21.8053 24.6242 19.3027 25.1025 19.3027 23.3586V15.57C19.3027 13.8261 21.8053 14.3044 24.0732 14.3044C30.4533 14.3044 30.4513 24.6242 24.0732 24.6242ZM21.833 22.0929C24.5615 22.0929 26.3119 22.4649 26.3119 19.0749C26.3119 16.4373 23.4008 16.8354 21.833 16.8357V22.0929Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4595 35.1461C32.1351 35.1461 31.8117 35.022 31.5648 34.7749L21.0498 24.2601C19.8709 23.0822 21.6617 21.2921 22.8394 22.4705L33.3544 32.9856C34.1556 33.7861 33.5746 35.1461 32.4595 35.1461Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7347 34.7569C21.6198 34.7569 21.0391 33.3971 21.84 32.5964L31.966 22.4707C33.1439 21.2918 34.9342 23.0824 33.7553 24.2603L23.6296 34.386C23.3824 34.6326 23.0583 34.7569 22.7347 34.7569Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4302 29.2885H49.052C47.3857 29.2885 47.3862 26.7573 49.052 26.7573H73.4292C75.0954 26.7573 75.0947 29.2885 73.4302 29.2885ZM44.3762 29.2885C42.0873 29.2885 39.5703 29.7698 39.5703 28.0229C39.5703 26.276 42.0873 26.7573 44.3762 26.7573C46.0424 26.7573 46.0424 29.2885 44.3762 29.2885Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6508 108H18.4687C17.7702 108 17.2031 107.432 17.2031 106.734V98.1843C17.2031 97.4857 17.7702 96.9186 18.4687 96.9186H65.7096L82.8344 79.8269V19.2563C82.8344 18.5578 83.4022 17.9907 84.1001 17.9907H92.6497C93.3483 17.9907 93.9153 18.5578 93.9153 19.2563V106.734C93.9163 107.433 93.3496 108 92.6508 108ZM19.7344 105.469H91.3839V20.5218H85.3663V80.3526C85.3663 80.689 85.2327 81.0109 84.9946 81.249L67.1268 99.0817C66.8886 99.3187 66.5677 99.4517 66.2324 99.4517H19.7343L19.7344 105.469Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/prescription.c76ce523c7e2020f83d3faa77db0eb72.svg";
export { ForwardRef as ReactComponent };